module.exports = __webpack_public_path__ + "static/media/lock_reset.295e20a5.svg";